var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poll-page-quests-block"},_vm._l((_vm.scope.poll.getQuests()),function(quest,index){return _c('quest-component',{key:index,attrs:{"index":index,"data":quest}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }